<template>
  <main class="container my-5">
    <h4>Minhas Assinaturas</h4>
    <ListarAssinaturas :objAssinaturas="objAssinaturas" />

    <div  v-if="infoAtend || infoCondGerais " class="px-4 py-3 mb-4 mt-2 shadow" >
      <div v-if="infoAtend" v-html="infoAtend"></div>
      <div v-if="infoCondGerais" v-html="infoCondGerais"></div>
    </div>

    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>
// @ is an alias to /src
import { APIService } from "../APIService";
const apiService = new APIService();
import ListarAssinaturas from "../components/assinaturas/ListarAssinaturas";
import Loading from "@/components/Loading.vue";

export default {
  name: "Assinaturas",
  components: {
    ListarAssinaturas,
    Loading
  },
  data() {
    return {
      objAssinaturas: {},
      loading: false,
      funcionalidades: null,
      infoAtend: null,
      infoCondGerais: null,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.obterMinhasAssinaturas();
    this.obterFuncionalidades();
  },
  methods: {
    obterMinhasAssinaturas() {
      this.loading = true;
      apiService.obterMinhasAssinaturas().then(response => {
        this.objAssinaturas = response;
        this.loading = false;
      });
    },
    obterFuncionalidades() {
      this.loading = true;
      apiService
        .getFuncionalidadeV2(window.APP_ORIGIN)
        .then((res) => {
         const funcionalidades =
            res.filter((e) => {
              return "MICROAPP_TEXTOS" == e.funcionalidade;
            });

          const valorString = funcionalidades[0].valorString;
          this.funcionalidades = JSON.parse(valorString);

          const atendInfo = this.funcionalidades.find(objeto => objeto.codigoMicroapp === "MAPP_INFO_ATEND");
          if (atendInfo && atendInfo.ativo) {
            const currentRoute = this.$route.path;
              let rotaCorresponde = false;
              for (const pagina of atendInfo.paginas) {
                  if (currentRoute.includes(pagina)) {
                      rotaCorresponde = true;
                      break;
                  }
              }

              if (rotaCorresponde) {
                this.infoAtend = atendInfo.html;
              }
          }

          const condGerais = this.funcionalidades.find(objeto => objeto.codigoMicroapp === "MAPP_COND_GERAIS");
          if (condGerais && condGerais.ativo) {
            const currentRoute = this.$route.path;
              let rotaCorresponde = false;
              for (const pagina of condGerais.paginas) {
                  if (currentRoute.includes(pagina)) {
                      rotaCorresponde = true;
                      break;
                  }
              }

              if (rotaCorresponde) {
                this.infoCondGerais = condGerais.html;
              }
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log("log error", error);
          this.loading = false;
        });
    },
  }
};
</script>
<style scoped lang="scss"></style>
